import {
  ADD_VEHICLE, CHANGE_STATUS_VEHICLE,
  DELETE_VEHICLE,
  EDIT_VEHICLE,
  GET_VEHICLES, GET_VEHICLES_IDLES, GET_VEHICLES_LOCATIONS,
} from "./vehicles.types";

export const getVehicles = (params, noLoad = false) => {
  return {
    type: GET_VEHICLES,
    payload: {
      params,
      noLoad
    },
  };
};

export const addVehicle = (body) => {
  return {
    type: ADD_VEHICLE,
    payload: {
      body,
    },
  };
};

export const editVehicle = (id, body) => {
  return {
    type: EDIT_VEHICLE,
    payload: {
      id,
      body,
    },
  };
};

export const deleteVehicle = (id) => {
  return {
    type: DELETE_VEHICLE,
    payload: {
      id,
    },
  };
};

export const changeStatus = (id, body) => {
  return {
    type: CHANGE_STATUS_VEHICLE,
    payload: {
      id,
      body,
    },
  };
};

export const getVehiclesIdles = (params) => {
  return {
    type: GET_VEHICLES_IDLES,
    payload: {
      params,
    },
  };
};

export const getVehiclesLocations = () => {
  return {
    type: GET_VEHICLES_LOCATIONS,
  };
};